module.exports = "pegasus/assets/x_gray.png";